class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    // CelluMove 26/10: grouped bundle lines remove all their packs at once; GBP bundle prices converted; countdown kept fresh
    this.addEventListener('click', (e) => {
      const ar = e.target.closest('[data-cm-rail]');
      if (ar) { const r = ar.parentNode.querySelector('.cm-up-rail'); r.scrollBy({ left: +ar.dataset.cmRail * r.clientWidth * 0.9, behavior: 'smooth' }); return; }
      const u = e.target.closest('[data-cm-undo-go]');
      if (u) { e.preventDefault(); this.cmUndo(); return; }
      const b = e.target.closest('[data-cm-remove-keys]');
      if (b) {
        e.preventDefault();
        // a whole bundle pack: keep what it was so the toast can put it back exactly (same Kaching properties)
        if (b.dataset.cmUndo) { this._cmUndo = { items: b.dataset.cmUndo, label: b.dataset.cmUndoLabel || 'Removed' }; }
        this.cmRemove(b);
        return;
      }
      // bundle pack stepper (snippets/cm-cart-packs): − removes the last pack, + adds the same pack again under a new group id
      const m = e.target.closest('[data-cm-pack-minus]');
      if (m) { e.preventDefault(); this.cmRemove({ dataset: { cmRemoveKeys: m.dataset.cmPackMinus }, set disabled(v) { m.disabled = v; } }); return; }
      const pl = e.target.closest('[data-cm-pack-plus]');
      if (pl) { e.preventDefault(); this.cmPackPlus(pl); }
    });
    new MutationObserver(() => this.cmFix()).observe(this, { childList: true, subtree: true });
    this.cmFix();
  }

  cmRemove(btn) {
    const updates = {};
    btn.dataset.cmRemoveKeys.split(',').filter(Boolean).forEach((k) => (updates[k] = 0));
    btn.disabled = true;
    fetch(`${routes.cart_update_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates, sections: this.getSectionsToRender().map((s) => s.id), sections_url: location.pathname }),
    })
      .then((r) => r.json())
      .then((state) => {
        if (state.item_count === 0) this.classList.add('is-empty');
        this.renderContents(state);
        if (this._cmUndo) setTimeout(() => this.cmToast(), 50);
      })
      .catch(() => (location.href = routes.cart_url));
  }

  cmToast() {
    const old = document.getElementById('cm-undo-toast');
    if (old) old.remove();
    const t = document.createElement('div');
    t.id = 'cm-undo-toast';
    t.className = 'cm-undo';
    t.innerHTML = '<span></span><button type="button" data-cm-undo-go></button>';
    t.querySelector('button').textContent = (window.cmT || {}).undo || 'Undo';
    t.querySelector('span').textContent = this._cmUndo.label;
    (this.querySelector('.drawer__inner') || this).appendChild(t);
    clearTimeout(this._cmToastT);
    this._cmToastT = setTimeout(() => { t.remove(); this._cmUndo = null; }, 6000);
  }

  cmUndo() {
    if (!this._cmUndo) return;
    let items = [];
    try { items = JSON.parse(this._cmUndo.items); } catch (e) { return; }
    items.forEach((it) => {
      const pr = Array.isArray(it.properties) ? Object.fromEntries(it.properties) : it.properties || {};
      Object.keys(pr).forEach((k) => (pr[k] = String(pr[k]).replace(/&quot;/g, '"')));
      it.properties = pr;
    });
    this._cmUndo = null;
    const t = document.getElementById('cm-undo-toast');
    if (t) t.remove();
    fetch(`${routes.cart_add_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: this.getSectionsToRender().map((s) => s.id), sections_url: location.pathname }),
    })
      .then((r) => r.json())
      .then((state) => { if (!state.status) { this.classList.remove('is-empty'); this.renderContents(state); } });
  }

  cmPackPlus(btn) {
    // Farid 28/10: + = ONE more legging in this pack (the row's own line n -> n+1, same Kaching pack), never a whole extra pack
    let items = [];
    try { items = JSON.parse(btn.dataset.cmPackPlus); } catch (e) { return; }
    const kp = (it) => { const pr = Array.isArray(it.properties) ? Object.fromEntries(it.properties) : it.properties || {}; return String(pr._cm_pack || '').replace(/&quot;/g, '"'); };
    const pack = ((items.map(kp).find((s) => /"id":/.test(s)) || '').match(/"id":\s*"([^"]*)"/) || [])[1];
    const tr = btn.closest('tr[id^="CartDrawer-Item-"]'), idx = tr ? parseInt(tr.id.replace('CartDrawer-Item-', ''), 10) : 0;
    const isMain = (l) => /"main":\s*true/.test(l.properties._cm_pack || '') && (!pack || (l.properties._cm_pack || '').indexOf('"' + pack + '"') > -1);
    btn.disabled = true;
    fetch(`${routes.cart_url}.js`, { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((cart) => {
        let line = idx && cart.items[idx - 1];
        if (!line || !isMain(line)) line = cart.items.find(isMain);
        if (!line) throw new Error('no pack line');
        return fetch(`${routes.cart_change_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: line.quantity + 1, sections: this.getSectionsToRender().map((s) => s.id), sections_url: location.pathname }),
        });
      })
      .then((r) => r.json())
      .then((state) => (state.status ? (btn.disabled = false) : this.renderContents(state)))
      .catch(() => (btn.disabled = false));
  }

  cmPackPlusWhole(btn) {
    const gid = Math.random().toString(36).slice(2, 6).toUpperCase();
    let items = [];
    try { items = JSON.parse(btn.dataset.cmPackPlus); } catch (e) { return; }
    // Liquid gives properties as [key, value] pairs with HTML-escaped quotes: back to an object, then a new group id
    items.forEach((it) => {
      const pr = Array.isArray(it.properties) ? Object.fromEntries(it.properties) : it.properties || {};
      Object.keys(pr).forEach((k) => (pr[k] = String(pr[k]).replace(/&quot;/g, '"')));
      if (pr._cm_pack) pr._cm_pack = pr._cm_pack.replace(/"id":\s*"[^"]*"/, '"id":"' + gid + '"');
      it.properties = pr;
    });
    btn.disabled = true;
    fetch(`${routes.cart_add_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: this.getSectionsToRender().map((s) => s.id), sections_url: location.pathname }),
    })
      .then((r) => r.json())
      .then((state) => (state.status ? (btn.disabled = false) : this.renderContents(state)))
      .catch(() => (btn.disabled = false));
  }

  // bundle prices in the drawer are GBP (Kaching values): convert them like cm-bundle.js, and paint the reservation timer
  cmFix() {
    if (this._cmFixing) return;
    this._cmFixing = true;
    const B = window.cmBase || 'GBP', c = (window.Shopify && Shopify.currency && Shopify.currency.active) || B;
    this.querySelectorAll('[data-cmb-gbp]:not([data-done])').forEach((e) => {
      let v = +e.dataset.cmbGbp;
      if (c !== B) v = Math.round(v * (window.cmRate ? cmRate() : 1));
      e.dataset.done = '1';
      e.textContent = window.cmMoney ? cmMoney(v) : '£' + (v / 100).toFixed(2);
    });
    // anchors in the store base currency (Kaching 1X prices) when the shopper sees another currency: same rate as the prices
    const r = c !== B && window.cmRate ? cmRate() : 1, M = (v) => (window.cmMoney ? cmMoney(v) : (v / 100).toFixed(2));
    this.querySelectorAll('s[data-cm-anc]:not([data-done])').forEach((s) => {
      s.dataset.done = '1';
      const old = Math.round(+s.dataset.cmAnc * r), fin = +s.dataset.cmFin, row = s.parentNode, sv = row.querySelector('[data-cm-save-word]');
      if (old > fin) {
        s.textContent = M(old); s.hidden = false;
        if (sv && fin > 0) { sv.textContent = sv.dataset.cmSaveWord + ' ' + M(old - fin); sv.hidden = false; }
      }
    });
    this.querySelectorAll('[data-cm-save]:not([data-done])').forEach((p) => {
      p.dataset.done = '1';
      const tot = +p.dataset.cmSave + Math.max(0, Math.round(+p.dataset.cmSaveB * r) - +p.dataset.cmSaveBfin), b = p.querySelector('b');
      if (b) b.textContent = M(tot);
      p.hidden = tot <= 0;
      const w = this.querySelector('[data-cm-was]');  // footer "Total ~~was~~ now" (Farid 370)
      if (w) { w.textContent = M(+w.dataset.cmWas + tot); w.hidden = tot <= 0; }
    });
    this.cmTick();
    // rail arrows: hide the one that can't scroll further
    this.querySelectorAll('.cm-up-railwrap').forEach((w) => {
      const r = w.querySelector('.cm-up-rail'), p = w.querySelector('.cm-up-arrow--prev'), n = w.querySelector('.cm-up-arrow--next');
      const upd = () => { p.disabled = r.scrollLeft < 4; n.disabled = r.scrollLeft + r.clientWidth >= r.scrollWidth - 4; };
      if (!r._cmA) { r._cmA = 1; r.addEventListener('scroll', upd, { passive: true }); }
      upd();
    });
    // a free gift whose pack was removed (Kaching group with no main line left) is removed too, so no gift stays without its pack
    const orphans = [...this.querySelectorAll('[data-cm-orphan]')].map((r) => r.dataset.cmOrphan);
    if (orphans.length && !this._cmOrphanBusy) {
      this._cmOrphanBusy = true;
      this.cmRemove({ dataset: { cmRemoveKeys: orphans.join(',') }, set disabled(v) {} });
      setTimeout(() => (this._cmOrphanBusy = false), 4000);
    }
    this._cmFixing = false;
  }

  cmTick() {
    const els = this.querySelectorAll('[data-cm-timer]');
    if (!els.length) return;
    let until = 0;
    try { until = +sessionStorage.getItem('cm_cart_until') || 0; } catch (e) {}
    if (until < Date.now()) {
      until = Date.now() + 600000;
      try { sessionStorage.setItem('cm_cart_until', until); } catch (e) {}
    }
    const left = Math.max(0, Math.round((until - Date.now()) / 1000));
    const txt = String(Math.floor(left / 60)).padStart(2, '0') + ':' + String(left % 60).padStart(2, '0');
    els.forEach((e) => { if (e.textContent !== txt) e.textContent = txt; });
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (this.classList.contains('active')) return;
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true },
    );

    document.body.classList.add('overflow-hidden');
    clearInterval(this._cmTimer);
    this.cmTick();
    this._cmTimer = setInterval(() => this.cmTick(), 1000);

    // cart-drawer-items is a CartItems subclass that extends createViewEventElement.
    // Its `view-event-trigger="manual"` skips auto-dispatch on connect; we fire
    // it here when the drawer opens, with `context: 'dialog'` from the payload attribute.
    this.querySelector('cart-drawer-items')?.dispatchViewEvent();
  }

  close() {
    clearInterval(this._cmTimer);
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
